<template>
    <div class="s2w-sequence-selector-wrap">
        <div
            v-if="service.rangeSelector.warning"
            class="message-tip"
            v-html="service.rangeSelector.warning"
        />
        <div class="s2w-sequence-selector">
            <div class="s2w-sequence-selector-label">
                <span>{{ $t('BaseSaveToWorkspace.sequence.selected') }}</span>
            </div>
            <div v-if="sequenceName">
                <input
                    v-model.trim="innerSeqName"
                    class="s2w-sequence-selector__input"
                    type="text"
                    @input="onNameChange"
                >
            </div>
            <div
                v-else
                class="s2w-sequence-selector-value"
            >
                {{ selectedCount }} {{ $t('BaseSaveToWorkspace.sequence.selected') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SequenceSelector',
    inject: ['service'],
    props: {
        sequenceName: {
            type: String,
            default: '',
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            innerSeqName: this.sequenceName,
        };
    },
    methods: {
        onNameChange() {
            this.$emit('update-name', this.innerSeqName);
        },
    },
};
</script>
